export default __webpack_public_path__ + "static/media/chips-n-dip.e35712a0.jpg";